module.exports = __webpack_public_path__ + "img/18.314a9b1d.jpg";